import { v4 as uuidv4 } from 'uuid';
import img1 from '../../assets/img/portfolio/cases1.webp';
import img2 from '../../assets/img/portfolio/cases2.webp';
import img3 from '../../assets/img/portfolio/cases3.webp';
import img4 from '../../assets/img/portfolio/cases4.webp';

const portfolioTwoData = [
    {
        id: uuidv4(),
        image: img1,
        name: 'Engine & Powertrain',
        heading: 'Genuine & Aftermarket Engine Parts',
        cost: 'Komatsu / CAT / Isuzu',
    },

    {
        id: uuidv4(),
        image: img2,
        name: 'Undercarriage',
        heading: 'Track Chains, Rollers & Sprockets',
        cost: 'ITM / Maguro / Black Tooth',
    },

    {
        id: uuidv4(),
        image: img3,
        name: 'Turbochargers',
        heading: 'Authorised Garrett Turbocharger Dealer',
        cost: 'Garrett / Holset / IHI / BorgWarner',
    },

    {
        id: uuidv4(),
        image: img4,
        name: 'Filtration & Seals',
        heading: 'Filtration Systems & Hydraulic Hoses',
        cost: 'Fleetguard / Donaldson / NOK',
    },
];

export default portfolioTwoData;
